import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 僅 DRAFT：刪除草稿資料（非 CANCELLED 狀態）。 */
export async function cancelStockIssue(id) {
  const { data: raw } = await request.delete(`/ims/stock-issue/${id}`);
  return parseVer4DetailResponse(raw);
}
